import React from 'react';
import {Link} from 'react-router-dom';
import {LanguageContext} from '../LanguageContext';
import translation from '../translations';
import goImg from '../images/good-order-v3.jpg';

const Complete = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div>
          <div className="text-right">
            <img className="w-90" src={goImg} alt="see-it-sort-it-report-it" />
          </div>

          <div className="p-4 pt-8">
            <div className="text-center">
              <h2>{translation.complete[lang.selected].COMPLETE}</h2>
            </div>

            <div className="flex flex-col p-4 pt-8">
              <div className="text-2xl bg-blue hover:bg-blue text-white font-bold py-2 px-4 m-3 text-center rounded">
                <Link to="/" className="no-underline text-white">
                  {translation.complete[lang.selected].HOME}
                </Link>
              </div>
              <div className="text-2xl bg-blue hover:bg-blue text-white font-bold py-2 px-4 m-3 text-center rounded">
                <Link to="/site" className="no-underline text-white">
                  {translation.complete[lang.selected].NEW_SUBMISSION}
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default Complete;



// WEBPACK FOOTER //
// ./src/components/Complete.js